<div class="qq-complete" [appScrollIntoView]="true">
  <app-questionnaire-summary title="Your Selected Coverage Options">
    <app-summary-row label="Type of cover">{{questionnaire.answerText('CoverType')}}</app-summary-row>
    <ng-container *ngIf="answers.CoverType === 'Mortgage'">
      <app-summary-row label="Mortgage Type">{{questionnaire.answerText('MortgageType')}}</app-summary-row>
      <app-summary-row label="Outstanding Amount">{{answers.MortgageAmount | appcurrency}}</app-summary-row>
      <app-summary-row label="Remaining Term">{{answers.MortgageTerm}} years</app-summary-row>
    </ng-container>
  
    <ng-container *ngIf="answers.CoverType === 'Income'">
      <app-summary-row label="Net Monthly Income">{{answers.MonthlyIncome | appcurrency}}</app-summary-row>
      <app-summary-row label="Number of Years of Income">{{answers.IncomeYears}} years</app-summary-row>
      <app-summary-row label="Current Age">{{answers.Age}}</app-summary-row>
      <app-summary-row label="Desired Retirement Age">{{answers.RetirementAge}}</app-summary-row>
      <app-summary-row *ngIf="answers.HaveChildren === 'N'" label="Children">none</app-summary-row>
      <ng-container *ngIf="answers.HaveChildren === 'Y'">
        <app-summary-row *ngFor="let child of childAges; let index = index"
          label="Child {{index+1}} Age">{{child}}</app-summary-row>
        <app-summary-row label="Include University">{{questionnaire.answerText('UniversityCover')}}</app-summary-row>
      </ng-container>
    </ng-container>
  </app-questionnaire-summary>
  <div class="apg-loading" *ngIf="loading">
    <ion-spinner></ion-spinner>
  </div>

  <div class="qq-complete__block" *ngIf="result && !loading">
    <div class="qq-complete__block__header">   
        Based on the answers that you have provided,
          we estimate your Best Fit {{coverTypeDisplay}} Cover as follows:
    </div> 
    <label>
      {{resultCoverTypeDisplay}} <br/>for {{result.term}} years
    </label>
    <div class="qq-complete__block__amount">
      <label class="amount">
        Sum Assured: {{result?.sumAssured | pounds}}
      </label>
    </div>
    <div class="qq-complete__block__header" *ngIf="result?.sumAssured > 1000000">
      The sum assured has exceeded our limit of £1,000,000 for Dividend Life. 
        If you wish to proceed with a quote, please click on "Get quote" and we will adjust the sum assured to £1,000,000,  
        otherwise please contact our support team at 0330 010 0210 for assistance and more options.
    </div>

    <div class="buttons">
      <ion-button (click)="back()" class="qq-complete__block-darkbtn">
        <ion-icon name="chevron-back-outline"></ion-icon>
        Back
      </ion-button>

        <ion-button class="qq-complete__block-darkbtn" (click)="next.emit(result)">
          Get quote
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
    </div>
  </div>
</div>